
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as EvaluateIconComponent } from "./evaluate-icon.svg";

export const EvaluateIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <EvaluateIconComponent {...props} />;
};
